// frontend/src/components/Common/SimpleSearchBar.js (versão 0.2.0 - Padronizado)

import React from 'react';
import { Search } from 'lucide-react';

/**
 * Componente de barra de busca padronizado
 * Suporta duas formas de uso para compatibilidade:
 * - value/onChange (padrão)
 * - searchTerm/onSearchChange (legado)
 */
const SimpleSearchBar = ({ 
    value, 
    onChange, 
    searchTerm, 
    onSearchChange,
    placeholder = 'Pesquisar...', 
    className = '' 
}) => {
    // Compatibilidade: suporta ambas as formas de props
    const currentValue = value !== undefined ? value : (searchTerm !== undefined ? searchTerm : '');
    const handleChange = onChange || onSearchChange || (() => {});

    return (
        <div className={`relative ${className}`}>
            <Search 
                className="absolute left-2.5 sm:left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 sm:h-5 sm:w-5 text-emerald-500" 
            />
            <input
                type="text"
                value={currentValue}
                onChange={handleChange}
                placeholder={placeholder}
                className="
                    w-full py-2 sm:py-2.5 pl-8 sm:pl-10 pr-3 sm:pr-4 
                    bg-white border border-gray-300 rounded-xl 
                    shadow-sm
                    focus:outline-none focus:border-emerald-400 focus:ring-2 focus:ring-emerald-400/10
                    transition-all duration-200 ease-in-out
                    text-sm sm:text-base text-gray-700 placeholder-gray-400
                    hover:border-gray-400
                "
                aria-label="Buscar"
            />
        </div>
    );
};

export default SimpleSearchBar;